import CountUp from "react-countup";

function SectionCounter1() {
    return (
        <>
            <div className="counter-blocks">
                <div className="row when-item-four justify-content-center pt-1">
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                        <div className="sx-count">
                            <h2 className="sx-title">
                                <span className="counter">
                                    <CountUp end={35} duration={13} />
                                </span>
                                <span className="sx-cont-before">+</span>
                                <span className="sx-cont-after"></span>
                            </h2>
                            <div className="sx-count-info">Active Member</div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                        <div className="sx-count">
                            <h2 className="sx-title">
                                <span className="counter">
                                    <CountUp end={50} duration={13} />
                                </span>
                                <span className="sx-cont-before">+</span>
                                <span className="sx-cont-after"></span>
                            </h2>
                            <div className="sx-count-info">Total Project</div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                        <div className="sx-count">
                            <h2 className="sx-title">
                                <span className="counter">
                                    <CountUp end={25} duration={13} />
                                </span>
                                <span className="sx-cont-before">+</span>
                            </h2>
                            <div className="sx-count-info">Team Member</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionCounter1;